module.exports = __webpack_public_path__ + "img/sl.f0281fcb.jpg";